"use client";

import DreamnOddValue from "./DreamnOddValue";

const THEME_ODDS_TEXT =
  "text-[var(--theme-text)]";

const LINE_CELL =
  "shrink-0 text-[10px] font-medium font-bold sm:text-xs md:text-sm min-w-[1rem] px-0.5 text-center tabular-nums sm:min-w-[1.125rem] md:min-w-[2rem] lg:min-w-[2.5rem] kbv-odds-line-navy-slate";

const PILL_WRAP =
  "kbv-dreamn-odds-pill box-border grid w-full max-w-full min-w-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-x-0 gap-y-0 rounded-md border border-white/50 bg-white/50 px-0.5 py-[2px] shadow-sm backdrop-blur-[2px] min-h-[20px] md:min-h-[22px] md:w-fit md:grid-cols-[auto_auto_auto] md:gap-x-1 md:px-1.5 [contain:layout]";

const OU_PILL_WRAP =
  "kbv-dreamn-odds-pill box-border flex w-full min-w-0 max-w-full flex-row items-center gap-x-0 md:gap-x-1 rounded-md border border-white/50 bg-white/50 px-0.5 py-[2px] md:px-1.5 shadow-sm backdrop-blur-[2px] min-h-[20px] md:min-h-[22px] [contain:layout]";

export function HdpCells({
  homeHandicap,
  handicapValue,
  awayHandicap,
  homeHandicapTrend,
  awayHandicapTrend,
}) {
  return (
    <div className={PILL_WRAP}>
      <div className="flex min-w-0 justify-start">
        <DreamnOddValue
          value={homeHandicap}
          trend={homeHandicapTrend}
          textClassName={THEME_ODDS_TEXT}
          align="start"
        />
      </div>
      <div className={`op ${LINE_CELL}`}>{handicapValue || "-"}</div>
      <div className="flex min-w-0 justify-end">
        <DreamnOddValue
          value={awayHandicap}
          trend={awayHandicapTrend}
          textClassName={THEME_ODDS_TEXT}
          align="end"
        />
      </div>
    </div>
  );
}

export function OuCells({
  overOdds,
  overUnderValue,
  underOdds,
  overTrend,
  underTrend,
}) {
  return (
    <div className={OU_PILL_WRAP}>
      <div className="flex min-w-0 flex-1 basis-0 justify-center">
        <DreamnOddValue
          value={overOdds}
          trend={overTrend}
          textClassName={THEME_ODDS_TEXT}
          align="center"
        />
      </div>
      <div className={`op ${LINE_CELL} shrink-0`}>{overUnderValue || "-"}</div>
      <div className="flex min-w-0 flex-1 basis-0 justify-center">
        <DreamnOddValue
          value={underOdds}
          trend={underTrend}
          textClassName={THEME_ODDS_TEXT}
          align="center"
        />
      </div>
    </div>
  );
}

export function X2Cells({
  home1x2,
  draw1x2,
  away1x2,
  home1x2Trend,
  draw1x2Trend,
  away1x2Trend,
}) {
  return (
    <div className="kbv-dreamn-odds-pill box-border grid w-full max-w-full min-w-0 grid-cols-3 items-center justify-items-center gap-0 rounded-md border border-white/50 bg-white/50 px-0.5 py-[2px] shadow-sm backdrop-blur-[2px] min-h-[20px] md:inline-grid md:w-fit md:grid-cols-[auto_auto_auto] md:gap-1 md:px-1.5 md:min-h-[22px] [contain:layout]">
      <div className="flex min-w-0 justify-center">
        <DreamnOddValue
          value={home1x2}
          trend={home1x2Trend}
          textClassName={THEME_ODDS_TEXT}
          align="center"
        />
      </div>
      <div className="flex min-w-0 justify-center">
        <DreamnOddValue
          value={draw1x2}
          trend={draw1x2Trend}
          textClassName="kbv-odds-line-navy-slate"
          align="center"
        />
      </div>
      <div className="flex min-w-0 justify-center">
        <DreamnOddValue
          value={away1x2}
          trend={away1x2Trend}
          textClassName={THEME_ODDS_TEXT}
          align="center"
        />
      </div>
    </div>
  );
}
